import { compactStatusSummaryVariant } from "../activity-evals/instance/status.js";
import { instanceCardStatus } from "../instance/instance-card-status.js";
//#region src/modules/ServicePeriods/calendar/calendar-event-from-instance.ts
function performanceVariantFromSummary(statusSummary) {
	if (!statusSummary || statusSummary.total === 0) return void 0;
	return compactStatusSummaryVariant(statusSummary);
}
function calendarEventFromInstance(instance, statusSummary, nowIso) {
	const life = instanceCardStatus(instance, nowIso);
	let appearance = "solid";
	let variant;
	if (life === "upcoming") {
		appearance = "dashed";
		variant = "info";
	} else if (life === "active") variant = "main";
	else variant = performanceVariantFromSummary(statusSummary) ?? "neutral";
	return {
		appearance,
		data: {
			instance,
			statusSummary
		},
		endsAt: Date.parse(instance.endsAt),
		key: instance.id,
		startsAt: Date.parse(instance.startsAt),
		variant
	};
}
function dayPerformanceVariant(events) {
	let hasCaution = false;
	let hasCritical = false;
	let hasPositive = false;
	for (const event of events) if (event.variant === "critical") hasCritical = true;
	else if (event.variant === "caution") hasCaution = true;
	else if (event.variant === "positive") hasPositive = true;
	if (hasCritical) return "critical";
	if (hasCaution) return "caution";
	if (hasPositive) return "positive";
}
/** Full literal class strings — Tailwind must see them unconcatenated. */
var DAY_PERFORMANCE_WASH = {
	caution: "bg-caution-faded",
	critical: "bg-critical-faded",
	positive: "bg-positive-faded"
};
function dayPerformanceClassName(events) {
	const variant = dayPerformanceVariant(events);
	return variant ? DAY_PERFORMANCE_WASH[variant] : void 0;
}
function rangePerformanceCounts(events) {
	let fulfilled = 0;
	let missed = 0;
	let partial = 0;
	for (const event of events) if (event.variant === "positive") fulfilled += 1;
	else if (event.variant === "caution") partial += 1;
	else if (event.variant === "critical") missed += 1;
	return {
		fulfilled,
		missed,
		partial,
		total: events.length
	};
}
//#endregion
export { calendarEventFromInstance, dayPerformanceClassName, dayPerformanceVariant, performanceVariantFromSummary, rangePerformanceCounts };

//# sourceMappingURL=calendar-event-from-instance.js.map